import DocumentsTemplates from './DocumentsTemplates';

export default DocumentsTemplates;
